define('ClearCart.View',
	[
		'SCView',
		'GlobalViews.Confirmation.View',
		'LiveOrder.Model',
		'ClearCart.Model',
		'Utils',
		'clear_cart.tpl'
	],

	function (
		SCViewComponent,
		GlobalViewsConfirmationView,
		LiveOrderModel,
		ClearCartModel,
		Utils,
		clear_cart_tpl
	) {

		'use strict'

		var SCView = SCViewComponent.SCView;

		function ClearCart(options) {

			SCView.call(this);

			this.options = options || {};

			this.template = clear_cart_tpl;

			this.initialize = function initialize(options) {
				this.liveOrder = LiveOrderModel.getInstance();
				this.model = new ClearCartModel();
			}

			this.initialize(options);

			this.handleClear = function handleClear(){
				var self = this;
				var confirmationView = new GlobalViewsConfirmationView({
					callBack: function () {
						self.emptyCart();
					},
					title: Utils.translate('Clear Cart'),
					body: Utils.translate("Do you want to clear the items on the cart? This action can not be undone."),
					autohide: true,
					className: 'cart-clear-btn'
				});
				self.options.container.getLayout().application.getLayout().showInModal(confirmationView);
			}

			this.emptyCart =  function emptyCart() {
				var self = this;
				self.model.fetch({
					method: 'DELETE'
				}).done(function () {
					self.liveOrder = LiveOrderModel.getInstance();
					self.liveOrder.fetch();
				});
			}
		}

		ClearCart.prototype = Object.create(SCView.prototype);

		ClearCart.prototype.constructor = ClearCart;

		ClearCart.prototype.getEvents = function getEvents() {
			return {
				'click [data-action="clear-cart"]': 'handleClear'
			};
		}

		ClearCart.prototype.getContext = function getContext() {
			return {};
		}

		return ClearCart;

	}

);
